import React from "react";
import { toast } from "react-toastify";
import { Button, DynamicDropdown, Form, TextInput } from "src/Components";
import {
  UserGoldInstrumentTaskTableReport,
  UserGoldInstrumentTaskUpsertDto,
} from "src/Interfaces/goldArbitrage";
import {
  getAccounts,
  getCashAssetDropdown,
  upsertUserGoldInstrumentTask,
} from "src/Requests/goldArbitrage";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  editValues?: UserGoldInstrumentTaskTableReport;
  onClose: () => void;
  onSuccess: () => void;
}

const AddEdit = ({ editValues, onClose, onSuccess }: IProps) => {
  const editValueMap = editValues as Record<string, any> | undefined;
  const [formValues, setFormValues] =
    React.useState<UserGoldInstrumentTaskUpsertDto>({
      id: editValues?.id,
      accountId: editValues?.userId,
      goldInstrumentId:
        editValues?.goldInstrumentId || editValueMap?.instrumentId,
      priorityWeight: editValues?.priorityWeight,
    });
  const [loading, setLoading] = React.useState(false);

  const changeHandler = (name: string, value: number | string) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = () => {
    setLoading(true);
    upsertUserGoldInstrumentTask(formValues)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onSuccess();
          onClose();
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="p-4 gap-4 !w-72">
      <DynamicDropdown
        dropdown={{
          name: "accountId",
          placeholder: "اکانت",
          extraLabel: true,
        }}
        getData={getAccounts}
        onChange={changeHandler}
        value={formValues.accountId}
      />
      <TextInput
        label="وزن اولویت"
        name="priorityWeight"
        onChange={changeHandler}
        value={formValues.priorityWeight?.toString()}
        kind="priceWithDecimal"
        extraLabel
      />
      <DynamicDropdown
        dropdown={{
          name: "goldInstrumentId",
          placeholder: "معیار",
          extraLabel: true,
        }}
        getData={getCashAssetDropdown}
        onChange={changeHandler}
        value={formValues.goldInstrumentId}
      />
      <Button
        text="ثبت"
        variant="contained"
        onClick={submitHandler}
        loading={loading}
      />
    </Form>
  );
};

export default AddEdit;
